import { all, call, fork, takeEvery } from 'redux-saga/effects';

import { CHANGE_SIDEBAR_TYPE } from './actionTypes';

/**
 * Changes the body attribute
 */
function changeBodyAttribute(attribute: any, value: any) {
  if (document.body) {
    document.body.setAttribute(attribute, value);
  }
  return true;
}

/**
 * Toggle the class on body
 * @param {*} cssClass
 * @param action
 */
function manageBodyClass(cssClass: any, action = 'toggle') {
  switch (action) {
    case 'add':
      if (document.body) {
        document.body.classList.add(cssClass);
      }
      break;
    case 'remove':
      if (document.body) {
        document.body.classList.remove(cssClass);
      }
      break;
    default:
      if (document.body) {
        document.body.classList.toggle(cssClass);
      }
      break;
  }

  return true;
}

/**
 * Changes the left sidebar type
 * @param {*} param0
 */
function* changeLeftSidebarType({payload: {sidebarType, isMobile}}: any) {
  try {
    switch (sidebarType) {
      case 'compact':
        yield call(changeBodyAttribute, 'data-sidebar-size', 'small');
        yield call(manageBodyClass, 'sidebar-enable', 'remove');
        yield call(manageBodyClass, 'vertical-collpsed', 'remove');
        break;
      case 'icon':
        yield call(changeBodyAttribute, 'data-keep-enlarged', 'true');
        yield call(manageBodyClass, 'vertical-collpsed', 'add');
        break;
      case 'condensed':
        yield call(manageBodyClass, 'sidebar-enable', 'add');
        if (!isMobile) {
          yield call(manageBodyClass, 'vertical-collpsed', 'add');
        }
        break;
      default:
        yield call(changeBodyAttribute, 'data-sidebar-size', '');
        yield call(manageBodyClass, 'sidebar-enable', 'remove');
        if (!isMobile) {
          yield call(manageBodyClass, 'vertical-collpsed', 'remove');
        }
        break;
    }
  } catch (error) {
  }
}

/**
 * Watchers
 */

export function* watchChangeLeftSidebarType() {
  yield takeEvery(CHANGE_SIDEBAR_TYPE, changeLeftSidebarType);
}

function* LayoutSaga() {
  yield all([
    fork(watchChangeLeftSidebarType)
  ]);
}

export default LayoutSaga;
